<template>
  <!-- 设置弹层-->
  <el-dialog title="设置"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-row type="flex" align="middle">
      <el-col :span="24">
        <el-form :model="userForm" :rules="rules" ref="userForm" label-width="90px" size="medium">
          <el-form-item label="登录名" prop="loginName">
            <el-input v-model="userForm.loginName" placeholder="请输入用户登录名"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="trueName">
            <el-input v-model="userForm.trueName" placeholder="请输入用户姓名"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="userForm.email" placeholder="请输入用户邮箱"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="userForm.phone" placeholder="请输入用户联系方式"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="userForm.sex">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <span slot="footer">
				<el-button @click="doClose" size="medium"><i class="fa fa-close"></i> 关闭</el-button>
				<el-button type="primary" @click="submit" size="medium"><i class="fa fa-save"></i> 确定</el-button>
			</span>
  </el-dialog>
</template>

<script>
import {get, update} from "@api/system/user";
import {mapGetters} from "vuex";

export default {
	name: 'edit-info',
  props: {
    visible: false
  },
  computed: {
    ...mapGetters(['user']),
  },
	data() {
		return {
      userForm: {},
      rules: {
        loginName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        email: [{ required: true, message: '请输入用户邮箱', trigger: 'change' }],
        phone: [{ required: true, message: '请输入用户联系方式', trigger: 'change' }]
			}
		}
	},
	methods: {
	  init(){
      get(this.user.id).then(resp => {
        this.userForm = resp.data.result
      })
    },
    doClose(){
      this.$emit('done', false)
    },
    submit() {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          update(this.userForm).then(resp => {
            this.$emit('done', true)
          })
        }
      })
    },
	}
}
</script>

